/* eslint-disable no-console */
import {useState} from 'react';

import {isAWSError} from '@fo/shared-types/typeChecks';
import {AWSError, User} from '@fo/shared-types';
import {useIdentityContext} from '@fo/shared-providers/IdentityContext';
import Identity, {Login} from '../../apis/Identity';

interface UseLoginResponse {
  error?: string;
  isLoading: boolean;
  isUserLoggedIn: boolean;
  submit: (formData: Login) => Promise<false | User>;
}

// @todo, move login functionality into `useIdentity`
// should move so that we can manage control flow of Identity state more easily (like with logout)
const useLogin = (): UseLoginResponse => {
  const {updateUser} = useIdentityContext();
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);
  const submit = (formData: Login): Promise<false | User> => {
    setIsLoading(true);
    setError(undefined);
    return Identity.login(formData)
      .then((user) => {
        setIsLoading(false);
        setIsUserLoggedIn(true);
        updateUser();
        return user;
      })
      .catch((apiError: AWSError | string) => {
        setIsLoading(false);
        if (isAWSError(apiError)) {
          setError(apiError.code);
        } else {
          setError(apiError);
        }
        return false;
      });
  };

  return {
    error,
    isLoading,
    isUserLoggedIn,
    submit,
  };
};

export default useLogin;
